module.exports = __webpack_public_path__ + "img/text-feedback.7276cdc1.svg";